<template>
  <v-sheet>
    <v-calendar color="primary" :value="calendarValue">
      <template v-slot:day="{ date }">
        <template v-for="event in eventsForDay(date)">
          <v-menu
            :key="event.parkFacilityReservationKey"
            full-width
            offset-x
          >
            <template v-slot:activator="{ on }">
              <div
                v-ripple
                v-on="on"
                role="button"
                tabindex="0"
                :aria-label="eventAriaLabel(event)"
                class="event-activator"
                :class="{event: true, 'event-cancelled': isCancelled(event), 'event-pandemic': isPandemic(event)}"
                @keydown.enter.prevent.stop="activateMenuFromKeyboard"
                @keydown.space.prevent.stop="activateMenuFromKeyboard"
              >
                <template v-if="results.scope=='park'">
                  <em>{{event.facilityName}}</em><br/>
                </template>
                <strong>{{formattedTime(event)}}</strong>
                <br/>
                {{event.reservationPurposeDsc}}
              </div>
            </template>
            <v-card color="grey lighten-4" min-width="350px" flat max-width="100%">
              <v-toolbar color="primary" dark>
                <v-toolbar-title v-html="event.reservationPurposeDsc"/>
              </v-toolbar>
              <v-card-title primary-title>
                <div class="body-1">Reservee: {{event.customerName}}</div>
              </v-card-title>
            </v-card>
          </v-menu>
        </template>
      </template>
    </v-calendar>
  </v-sheet>
</template>

<script>
  import moment from 'moment'

  export default {
    props: ['results'],
    computed: {
      calendarValue() {
        return moment()
          .month(this.$store.state.details.month-1)
          .year(this.$store.state.details.year)
          .date(1)
          .format('YYYY-MM-DD')
      }
    },
    methods: {
      eventsForDay (date) {
        const key = date.toString()
        if (!this.results.cal || !(key in this.results.cal)) return []
        return this.results.cal[key]
      },
      eventAriaLabel (event) {
        const parts = []
        if (this.results.scope === 'park') parts.push(event.facilityName)
        parts.push(this.formattedTime(event))
        parts.push(event.reservationPurposeDsc)
        if (this.isCancelled(event)) parts.push('Canceled due to inclement weather')
        if (this.isPandemic(event)) parts.push('Canceled due to DPR closure')
        parts.push('Press Enter or Space for details')
        return parts.join('. ')
      },
      activateMenuFromKeyboard (e) {
        if (e.currentTarget && typeof e.currentTarget.click === 'function') {
          e.currentTarget.click()
        }
      },
      formattedTime (event) {
        return [
          moment(event.reservationBeginDtm).format('h:mma'),
          moment(event.reservationEndDtm).format('h:mma')
        ].join(' - ')
      },
      isCancelled(event) {
        return event.reservationStatusCode == "Cancelled" && event.reservationPurposeDsc == "Inclement Weather"
      },
      isPandemic(event) {
        return event.reservationStatusCode == "Cancelled" && event.reservationPurposeDsc == "DPR Closure COVID-19"
      }
    }
  }
</script>

<style>
  .event-activator {
    position: relative;
  }
  .event {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    border-radius: 2px;
    background-color: #2e8be8;
    color: #ffffff;
    border: 1px solid #2e8be8;
    width: 100%;
    font-size: 12px;
    padding: 3px;
    margin-top: 6px;
    cursor: pointer;
    margin-bottom: 1px;
  }
  .event-cancelled {
    background-color: #E53935;
    border-color: #E53935;
  }
  .event-pandemic {
    background-color: orange;
    border-color: orange;
  }
  .v-calendar-weekly__day {
    min-height: 85px;
  }

  /* IE11 calendar layout "fix" */
  _:-ms-fullscreen, :root .v-calendar-weekly__week {
    padding-bottom: 200px;
  }
  _:-ms-fullscreen, :root .v-calendar-weekly__day {
    height: 200px;
    overflow: scroll;
  }
</style>